import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex items-end gap-3" }
const _hoisted_2 = { class: "flex flex-col justify-center items-center mb-3 grow" }
const _hoisted_3 = { class: "flex justify-center mb-3" }
const _hoisted_4 = { class: "flex flex-col justify-center items-center" }
const _hoisted_5 = {
  key: 0,
  class: "grid grid-cols-1 gap-3"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex flex-col col-span-2 justify-center items-center pt-3" }
const _hoisted_8 = { class: "text-next-orange" }
const _hoisted_9 = { class: "flex justify-end" }
const _hoisted_10 = { class: "flex justify-end pt-3" }
const _hoisted_11 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_12 = { class: "flex justify-between items-center" }
const _hoisted_13 = { class: "py-5 text-2xl font-bold" }
const _hoisted_14 = { class: "flex justify-between" }
const _hoisted_15 = { class: "flex flex-col mb-3" }
const _hoisted_16 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Modal, {
        visible: _ctx.visible,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
        backdrop: "true"
      }, {
        header: _withCtx(() => _cache[9] || (_cache[9] = [
          _createElementVNode("p", { class: "font-bold text-xl" }, "Importa previsionale commerciale", -1)
        ])),
        main: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Field, {
                field_name: "Anno",
                modelValue: _ctx.anno,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.anno) = $event)),
                type: "number",
                inputAttrs: {step:'1'}
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_FileUpload, {
                uploaded_files: _ctx.uploaded,
                "onUpdate:uploaded_files": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.uploaded) = $event)),
                accept: ".xlx,.xls,.xlsx"
              }, {
                default: _withCtx(({props, methods}) => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_NextButton, {
                      variant: "outline-secondary",
                      onClick: methods.open,
                      class: "w-56 h-10 px-4 grow"
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1),
                        _createTextVNode(" Allega ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["uploaded_files"])
            ])
          ]),
          (_ctx.uploaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploaded, (f, idx) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: "underline text-sm text-next-atp pt-3 cursor-pointer",
                    onClick: ($event: any) => (_ctx.downloadFile(f?.id)),
                    target: "_blank",
                    key: idx
                  }, [
                    _createElementVNode("span", null, _toDisplayString(f.name), 1)
                  ], 8, _hoisted_6))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Radio, {
              value: "aggiorna",
              name: "type",
              modelValue: _ctx.tipologia_scrittura,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tipologia_scrittura) = $event)),
              checkClass: "w-3 h-3"
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("Aggiorna valori esistenti ")
              ])),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_Radio, {
              value: "sovrascrivi",
              name: "type",
              modelValue: _ctx.tipologia_scrittura,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tipologia_scrittura) = $event)),
              checkClass: "w-3 h-3"
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("Cancella esistenti ")
              ])),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (_ctx.errors.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_Alert, { class: "mt-3 bg-next-orange" }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("Importazione interrotta a causa dei seguenti errori")
                  ])),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (e) => {
                  return (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(e), 1))
                }), 256))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_NextButton, {
                variant: "outline-secondary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.visible = false)),
                class: "col-start-3 py-2 px-4"
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode(" Chiudi ")
                ])),
                _: 1
              }),
              _createVNode(_component_NextButton, {
                variant: "primary",
                onClick: _ctx.importa,
                class: "ml-4 py-2 px-4"
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode(" Importa ")
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h1", _hoisted_13, "Previsionale commerciale per " + _toDisplayString(_ctx.business_unit?.nome), 1),
        _createVNode(_component_NextButton, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.visible = !_ctx.visible)),
          class: "py-1 px-3"
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [
            _createTextVNode(" Importa ")
          ])),
          _: 1
        }),
        _createVNode(_component_NextButton, {
          component: "router-link",
          to: {name:'DettaglioBilancioPrevisionaleNew', params:{id:_ctx.id}},
          class: "py-1 px-3"
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [
            _createTextVNode(" Nuovo ")
          ])),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_Field, {
            field_name: "Cerca",
            "onUpdate:modelValue": [
              _ctx.lista.debounceSearch,
              _cache[7] || (_cache[7] = ($event: any) => ((_ctx.lista.search) = $event))
            ],
            modelValue: _ctx.lista.search,
            placeholder: "Cerca"
          }, null, 8, ["onUpdate:modelValue", "modelValue"])
        ]),
        _createVNode(_component_Paginator, {
          class: "",
          pagination: _ctx.lista.paginate
        }, null, 8, ["pagination"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_NextTable, {
          class: "rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4",
          cols: _ctx.cols,
          "onUpdate:cols": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.cols) = $event)),
          rows: _ctx.lista.rows,
          onOrderUpdate: _ctx.lista.updateCols
        }, _createSlots({ _: 2 }, [
          _renderList(_ctx.lista.rows, (c, j) => {
            return {
              name: `td_${j}_3`,
              fn: _withCtx(({context}) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(context.row.previsto)), 1)
              ])
            }
          }),
          _renderList(_ctx.lista.rows, (c, j) => {
            return {
              name: `td_${j}_4`,
              fn: _withCtx(({context}) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(context.row.progresso)), 1)
              ])
            }
          }),
          _renderList(_ctx.lista.rows, (c, j) => {
            return {
              name: `td_${j}_5`,
              fn: _withCtx((context) => [
                _createVNode(_component_router_link, {
                  to: {name:'DettaglioBilancioPrevisionale', params:{id:_ctx.id, bid:context.context.row.id}},
                  class: "text-center inset-0 absolute flex items-center justify-center"
                }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                  ])),
                  _: 2
                }, 1032, ["to"])
              ])
            }
          })
        ]), 1032, ["cols", "rows", "onOrderUpdate"])
      ]),
      _createVNode(_component_InfiniteLoading, {
        onInfinite: _ctx.lista.fetchNextPage,
        identifier: _ctx.lista.infiniteIdentifier,
        style: {"min-height":"1px"}
      }, {
        complete: _withCtx(() => _cache[19] || (_cache[19] = [
          _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altre righe.", -1)
        ])),
        _: 1
      }, 8, ["onInfinite", "identifier"])
    ])
  ], 64))
}